import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1412127501/src/doomum-frontend/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1412127501/src/doomum-frontend/src/features/coming-soon/coming-soon.tsx");
